import React from 'react';
import {
  IconButton,
  Toolbar,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import clsx from 'clsx';

import PropTypes from 'prop-types';

import { deleteToolBar } from '../../styles/formElementsStyles';

import translations from '../../languages/i18n';

export default function DeleteToolBar({ handleClick, numSelected }) {
  const formStyles = deleteToolBar();

  return (
    <Toolbar className={clsx(formStyles.root, { [formStyles.highlight]: numSelected > 0 })}>
      <Typography className={formStyles.title} color='inherit' variant='subtitle1' component='div'>{numSelected} {translations['_selected']}</Typography>
      <Tooltip title='Delete' margin='normal'>
        <IconButton aria-label='delete' onClick={handleClick}>
          <Delete />
        </IconButton>
      </Tooltip>
    </Toolbar>
  );
}

DeleteToolBar.propTypes = {
  handleClick: PropTypes.func.isRequired,
  numSelected: PropTypes.number.isRequired,
};
